///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Toolbar } from 'ngx-editor';
import { defaultToolbarRules, NoteItem } from './release-notes-note-item.model';

export class ReleaseNotesAboutSikluModel implements NoteItem {
    public readonly DIALOG_TITLE_TRANSLATION_PATH = 'releaseNotes.aboutSiklu.EditLabel';
    public fieldList: { title: string; content: string; editorToolbar: Toolbar }[] = [];

    constructor(
        public description?: string,
        public baseInfo?: string,
        public tel?: string,
        public fax?: string,
        public email?: string
    ) {
        this.fieldList.push({ title: 'description', content: this.description, editorToolbar: defaultToolbarRules });
        this.fieldList.push({ title: 'baseInfo', content: this.baseInfo, editorToolbar: defaultToolbarRules });
        this.fieldList.push({ title: 'tel', content: this.tel, editorToolbar: [] });
        this.fieldList.push({ title: 'fax', content: this.fax, editorToolbar: [] });
        this.fieldList.push({ title: 'email', content: this.email, editorToolbar: [] });
    }

    getPlainObject(): any {
        const releaseNoteItem = {};
        this.fieldList.forEach((field) => (releaseNoteItem[field.title] = field.content));
        return releaseNoteItem;
    }
}
